import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

type PackagingDocumentSameNameReuseAlertLabels = {
  title: string
  description: string
  reuseCta: string
  attaching: string
}

type PackagingDocumentSameNameReuseAlertProps = {
  fileName: string
  labels: PackagingDocumentSameNameReuseAlertLabels
  isAttaching?: boolean
  canReuse?: boolean
  onReuse?: () => void
}

export function PackagingDocumentSameNameReuseAlert({
  fileName,
  labels,
  isAttaching = false,
  canReuse = true,
  onReuse,
}: PackagingDocumentSameNameReuseAlertProps) {
  const showReuseButton = canReuse && onReuse != null
  const reuseLabel = labels.reuseCta.replace('{{fileName}}', fileName)

  return (
    <Alert variant='default' className='border-amber-500/50 bg-amber-500/5'>
      <AlertTriangle className='text-amber-600' />
      <AlertTitle>{labels.title}</AlertTitle>
      <AlertDescription className='space-y-3'>
        <p>{labels.description}</p>
        {showReuseButton && (
          <Button
            type='button'
            size='sm'
            disabled={isAttaching}
            onClick={onReuse}
          >
            {isAttaching ? labels.attaching : reuseLabel}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  )
}
